import React, { Component } from 'react';
import { Form, Icon, Input, Button } from 'antd';
import { resetPassword } from './mutations/resetPassword';
import { graphql } from 'react-apollo';
import PasswordResetComplete from "./reset_complete";
import displayServerErrors from '../../../utilities/form/display_server_errors';
import { PeekPasswordButton } from '../../common/peekPasswordButton/peekPasswordButton';
import './form.css';

const FormItem = Form.Item;

class ResetPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      passwordType: 'password',
      passwordConfirmationType: 'password',
      confirmDirty: false,
      user: null
    };
  }

  get mutationParams() {
    return {
      variables: {
        input: {
          password: this.props.form.getFieldValue('password'),
          token: this.props.token
        }
      }
    };
  }

  async submitData() {
    try {
      this.setState({ loading: true });
      const { data } = await this.props.mutate(this.mutationParams);
      this.setState({ user: data.resetPassword.user, isNewPassword: data.resetPassword.isNewPassword });
    } catch(response) {
      displayServerErrors(this.props.form, response, { 'password': 'password' });
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit(event) {
    event.preventDefault();

    this.props.form.validateFields((error, _values) => {
      if (!error) {
        this.submitData();
      }
    });
  }

  showHidePassword = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ passwordType: this.state.passwordType === 'input' ? 'password' : 'input' })
  }

  showHidePasswordConfirmation = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ passwordConfirmationType: this.state.passwordConfirmationType === 'input' ? 'password' : 'input' })
  }

  handleConfirmBlur = (event) => {
    this.setState({ confirmDirty: this.state.confirmDirty || !!event.target.value });
  };

  checkPassword = (rule, value, callback) => {
    if (value && value !== this.props.form.getFieldValue('password')) {
      callback('Password and confirmation must match');
    } else {
      callback();
    }
  };

  checkConfirm = (rule, value, callback) => {
    if (value && this.state.confirmDirty) {
      this.props.form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    if (this.state.user) {
      return <PasswordResetComplete user={ this.state.user } isNewPassword={ this.state.isNewPassword }/>;
    } else {
      const { getFieldDecorator } = this.props.form;
      return (
        <Form onSubmit={this.onSubmit.bind(this)} className="reset-password-form">
          <h1 className="reset-password-form__header">Create new password</h1>
          <p>for <b className="reset-password-form__user-email">{this.props.email}</b></p>
          <FormItem>
            {getFieldDecorator('password', {
              rules: [
                { required: true, message: "Please enter new password" },
                { validator: this.checkConfirm }
              ]
            })(
              <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                     suffix={<PeekPasswordButton passwordType={this.state.passwordType}
                                                 onClick={this.showHidePassword}/>}
                     type={this.state.passwordType}
                     placeholder="Password" />
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('confirm', {
              rules: [
                { required: true, message: "Please enter confirmation" },
                { validator: this.checkPassword }
              ]
            })(<Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                      suffix={<PeekPasswordButton passwordType={this.state.passwordConfirmationType}
                                                  onClick={this.showHidePasswordConfirmation}/>}
                      type={this.state.passwordConfirmationType}
                      onBlur={this.handleConfirmBlur}
                      placeholder="Repeat password" />
            )}
          </FormItem>
          <FormItem>
            <Button type="primary" htmlType="submit" className="reset-password-form__save-button" loading={this.state.loading}>
              <b>SAVE</b> {this.state.loading}
            </Button>
          </FormItem>
        </Form>
      );
    }
  }
}

export default Form.create()(graphql(resetPassword)(ResetPasswordForm));


// WEBPACK FOOTER //
// ./src/components/pages/reset_password/form.js